/* Estrani - kleurkeuze met fotostaaltjes op de productpagina.

   Haalt de foto per kleur uit de varianten van het product zelf, net zoals de
   bolletjes op de kaarten. Verandert niets aan de catalogus en niets aan de
   werking van de keuzeknoppen: de radio-inputs van het thema blijven staan,
   alleen hun uiterlijk verandert.

   SNELHEID. Dit script draait vanuit de <head> (zie snippets/ai-hoofd.liquid)
   en zonder defer. Het zet meteen een kijker op de pagina en bouwt de knoppen
   om op het moment dat de browser ze inleest. Daarvoor stond het onderaan de
   pagina met defer en haalde het eerst /products/<handle>.js op; die twee
   samen waren precies de tijd dat je de tekstknoppen zag staan. De lijst komt
   nu kant-en-klaar uit Liquid; het netwerkrondje blijft alleen als vangnet
   voor pagina's waar die lijst niet meegegeven wordt.

   Door Claude, veilig te verwijderen. */
(function () {
  'use strict';
  if (window.__aiKleurFotos) return;
  window.__aiKleurFotos = true;

  var KLEUR = /kleur|colou?r/i;
  var KAART = null;
  var BEZIG = false;
  var KIJKER = null;
  var OPGEHAALD = false;

  function breedte(url, px) {
    if (!url) return '';
    return url.indexOf('?') > -1 ? url + '&width=' + px : url + '?width=' + px;
  }

  /* De lijst die Liquid in de pagina zette. */
  function uitPagina() {
    var el = document.getElementById('ai-kleurfotos-data');
    if (!el) return null;
    try {
      var k = JSON.parse(el.textContent);
      for (var x in k) { if (Object.prototype.hasOwnProperty.call(k, x)) return k; }
    } catch (e) { /* stuk json: dan maar via het netwerk */ }
    return null;
  }

  function kleurVeld() {
    var picker = document.querySelector('variant-picker[data-product-handle]');
    if (!picker) return null;
    var velden = [].slice.call(picker.querySelectorAll('fieldset'));
    for (var i = 0; i < velden.length; i++) {
      var inp = velden[i].querySelector('input[data-option-name]');
      if (inp && KLEUR.test(inp.getAttribute('data-option-name'))) return velden[i];
    }
    return null;
  }

  function benoem(veld) {
    var leg = veld.querySelector('legend');
    var gekozen = veld.querySelector('input:checked');
    if (!leg || !gekozen) return;
    var basis = leg.getAttribute('data-ai-basis');
    if (!basis) {
      basis = (leg.textContent || '').trim();
      leg.setAttribute('data-ai-basis', basis);
    }
    leg.textContent = basis;
    var naam = document.createElement('span');
    naam.className = 'ai-kf__naam';
    naam.textContent = gekozen.value;
    leg.appendChild(naam);
  }

  function pasToe(veld) {
    var labels = [].slice.call(veld.querySelectorAll('.variant-option__button-label'));
    if (!labels.length) return false;
    /* Alles of niets: mist een kleur zijn foto, dan laten we de tekstknoppen
       staan. Half fotos en half tekst ziet er rommelig uit. */
    for (var i = 0; i < labels.length; i++) {
      var inp = labels[i].querySelector('input');
      if (!inp || !KAART[inp.value]) {
        /* Niet elke ronde opnieuw proberen; dit product komt niet in aanmerking. */
        veld.setAttribute('data-ai-kf', 'nee');
        return false;
      }
    }
    labels.forEach(function (l) {
      var inp = l.querySelector('input');
      l.style.setProperty('--ai-kf', 'url("' + breedte(KAART[inp.value], 200) + '")');
      l.classList.add('ai-kf');
    });
    veld.classList.add('ai-kf-veld');
    benoem(veld);
    veld.addEventListener('change', function () { setTimeout(function () { benoem(veld); }, 0); });
    return true;
  }

  /* Kies je een kleur, dan hertekent het thema het hele keuzeblok en zijn onze
     staaltjes weg. Deze kijker zet ze meteen terug, nog voor de browser tekent.
     Hij doet dubbel dienst: tijdens het inlezen van de pagina pikt hij het
     keuzeblok op zodra het bestaat. */
  function herstel() {
    if (BEZIG) return;
    if (!KAART) {
      KAART = uitPagina();
      if (!KAART) return;
    }
    var veld = kleurVeld();
    if (!veld) return;
    if (veld.classList.contains('ai-kf-veld')) return;
    if (veld.getAttribute('data-ai-kf') === 'nee') return;
    BEZIG = true;
    pasToe(veld);
    BEZIG = false;
  }

  function kijk() {
    if (KIJKER) return;
    /* Op documentElement en niet op body: dit script draait in de <head>, en
       dan bestaat body nog niet. */
    KIJKER = new MutationObserver(herstel);
    KIJKER.observe(document.documentElement, { childList: true, subtree: true });
  }

  /* Vangnet voor pagina's zonder de lijst uit Liquid. */
  function haalOp() {
    if (OPGEHAALD || KAART) return;
    var picker = document.querySelector('variant-picker[data-product-handle]');
    var handle = picker && picker.getAttribute('data-product-handle');
    if (!handle) return;
    OPGEHAALD = true;
    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        if (!p) return;
        var idx = -1;
        (p.options || []).forEach(function (o, i) {
          var n = typeof o === 'string' ? o : (o && o.name) || '';
          if (KLEUR.test(n)) idx = i;
        });
        if (idx < 0) return;
        var kaart = {};
        (p.variants || []).forEach(function (v) {
          var k = v.options[idx];
          if (k && !kaart[k] && v.featured_image && v.featured_image.src) kaart[k] = v.featured_image.src;
        });
        KAART = kaart;
        var veld = kleurVeld();
        if (veld) { veld.removeAttribute('data-ai-kf'); pasToe(veld); }
      })
      .catch(function () {});
  }

  function start() {
    herstel();
    if (!KAART) haalOp();
  }

  kijk();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
